(function ($) {
    $(document).ready(function () {

        function handle_form_cta (form, _callback) {
            // Enter loading state
            form.addClass('loading');
            let form_data = new FormData();
            // Add form action
            form_data.append('action', form.attr('data-action'));
            // Add all fields
            form.serializeArray().reduce(function (obj, item) {
                form_data.append(item.name, item.value);
            }, {});

            // ajax
            $.ajax({
                url: ajaxurl,
                data: form_data,
                type: 'POST',
                processData: false,
                contentType: false,
                success: function (r, textStatus, jqXHR) {
                    _callback(r);
                }
            });
        }

        document.querySelector('input').addEventListener('invalid',
            function (event) {
                event.preventDefault();
                $(this).closest('form').submit();
            });

        $('form.auto[data-action="ajax_redirect_to_preferences"]').submit(function (e) {
            e.preventDefault();
            let form = $(this);
            if (!validate_form_cta(form)) {
                e.preventDefault();
                form.addClass('gform_validation_errors');
                return false;
            }
            handle_form_cta(form, function (response) {
                form.removeClass('loading');
                response = JSON.parse(response);
                if (response.success) {
                    form.addClass('success');

                    if (response.hasOwnProperty('redirect')) {
                        window.location.replace(response.redirect);
                    }

                }

            });

            return false;
        });

        function validate_form_cta (form) {
            form.removeClass('gform_validation_errors');
            form.find('.gfield').removeClass('gfield_error');

            let valid = true;

            form.find('.required').each(function () {
                let input = $(this);
                let parent = input.parents('.gfield');
                let pattern = ''
                switch (input.attr('type')) {
                    case 'email':
                         pattern = /^\b[A-Z0-9._%-]+@[A-Z0-9.-]+\.[A-Z]{2,4}\b$/i;

                        if (input.val().trim() == '' || !pattern.test(input.val())) {
                            parent.addClass('gfield_error');
                            valid = false;
                        }
                        break;

                }
            });

            return valid;
        }

        let searchParams = new URLSearchParams(window.location.search);
        if (searchParams.has('status')) {
            let param = searchParams.get('status');
            if (param == 'modified') {
                $('.mailchimp-form .mailchimp-form__message').show();
            }

        }
    });
})(jQuery);
